import { Link } from "react-router-dom";
import { hasRole } from "../../../components/Utils";
import { OvalLoader } from "../../../components/common/Loader";

// Card configuration with icons, colors, and data mapping
const cardConfig = [
  {
    key: "countries",
    label: "Countries",
    icon: "bx-globe",
    tone: "navy",
    dataKey: "countryCount",
    link: "/countries",
    permission: "countries-list",
    roles: [1],
  },
  {
    key: "states",
    label: "States",
    icon: "bx-map",
    tone: "navy",
    dataKey: "stateCount",
    link: "/states",
    permission: "states-list",
    roles: [1, 6],
  },
  {
    key: "regions",
    label: "Regions",
    icon: "bx-map-pin",
    tone: "navy",
    dataKey: "regionCount",
    link: "/regions",
    permission: "regions-list",
    roles: [1, 6, 7],
  },
  {
    key: "chapters",
    label: "Chapters",
    icon: "bx-buildings",
    tone: "navy",
    dataKey: "chapterCount",
    link: "/chapters",
    permission: "chapters-list",
    roles: [1, 6, 7, 2],
  },
  {
    key: "members",
    label: "Members",
    icon: "bx-group",
    tone: "navy",
    dataKey: "usersCount",
    link: "/users",
    permission: "members-list",
    roles: null,
  },
  // { key: "countryAdmins", label: "Country Admins", icon: "bx-shield-quarter", color: "#163586", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "countryAdminUsersCount", link: "/country-admin-users", permission: "country-admins-list", roles: [1] },
  // { key: "stateAdmins", label: "State Admins", icon: "bx-shield-quarter", color: "#163586", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "stateAdminUsersCount", link: "/state-admin-users", permission: "state-admins-list", roles: [1, 6] },
  // { key: "regionAdmins", label: "Region Admins", icon: "bx-shield-quarter", color: "#163586", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "regionAdminUsersCount", link: "/region-admin-users", permission: "region-admins-list", roles: [1, 6, 7] },
  // { key: "chapterAdmins", label: "Chapter Admins", icon: "bx-shield-quarter", color: "#163586", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "chapterAdminUsersCount", link: "/chapter-admin-users", permission: "chapter-admins-list", roles: [1, 6, 7, 2] },
  {
    key: "fbms",
    label: "121s",
    icon: "bx-message-rounded-dots",
    tone: "navy",
    dataKey: "one2oneCount",
    link: "/one-to-one",
    permission: "dashboard-121s-data-view",
    roles: null,
  },
  {
    key: "rfls",
    label: "RFLs",
    icon: "bx-transfer-alt",
    tone: "navy",
    dataKey: "referralsCount",
    link: "/referrals",
    permission: "dashboard-rfls-data-view",
    roles: null,
  },
  {
    key: "tyns",
    label: "TYNs",
    icon: "bx-heart",
    tone: "navy",
    dataKey: "tynsCount",
    link: "/tyfcbs",
    permission: "dashboard-tyns-data-view",
    roles: null,
  },
  {
    key: "generalVisitors",
    label: "General Visitors",
    icon: "bx-user-plus",
    tone: "navy",
    dataKey: "generalVisitorsCount",
    link: "/visitors/general",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "chiefGuest",
    label: "Chief Guest",
    icon: "bx-crown",
    tone: "navy",
    dataKey: "chiefGuestCount",
    link: "/visitors/chief-guest",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "inductions",
    label: "Inductions",
    icon: "bx-medal",
    tone: "navy",
    dataKey: "inductionsCount",
    link: "/visitors/inductions",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "powerDate",
    label: "Power Date",
    icon: "bx-calendar-check",
    tone: "navy",
    dataKey: "powerDateCount",
    link: "/visitors/power-date",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  // { key: "events", label: "Events", icon: "bx-calendar-event", color: "#163586", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "eventsCount", link: "/events", permission: "events-list", roles: null },
];

const AnalyticsCards = ({ data, ovalLoading, hasPermission }) => {
  // Filter visible cards based on role and permission
  const visibleCards = cardConfig.filter((card) => {
    if (card.roles && !hasRole(card.roles)) return false;
    if (!hasPermission(card.permission)) return false;
    return true;
  });

  return (
    <div className="analytics-cards-grid">
      {visibleCards.map((card) => (
        <Link
          to={card.link}
          key={card.key}
          className={`analytics-grid-card is-${card.tone}`}
        >
          <div className="analytics-grid-card-content">
            <div className="analytics-grid-card-data">
              <span className="analytics-grid-card-label">{card.label}</span>
              <span className="analytics-grid-card-value">
                {ovalLoading ? (
                  <OvalLoader color="#1E3A93" />
                ) : (
                  (data[card.dataKey] || 0).toLocaleString("en-IN")
                )}
              </span>
            </div>
            <div className="analytics-grid-card-icon">
              <i className={`bx ${card.icon}`} aria-hidden="true"></i>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default AnalyticsCards;
